import script from "./compNewsStatsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./compNewsStatsPanel.vue?vue&type=script&setup=true&lang=js"

import "./compNewsStatsPanel.vue?vue&type=style&index=0&id=b96c0ef2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b96c0ef2"]])

export default __exports__